import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7212ead9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-7212ead9><div class=\"formation-card\" data-v-7212ead9><div class=\"formation-icon-wrapper\" data-v-7212ead9><i class=\"flaticon-education formation-icon\" data-v-7212ead9></i></div><div class=\"formation-content\" data-v-7212ead9><h5 class=\"formation-title\" data-v-7212ead9>La Petite Voie de Sainte Thérèse de l&#39;enfant Jésus</h5><div class=\"formation-niveau\" data-v-7212ead9><i class=\"flaticon-level\" data-v-7212ead9></i><span data-v-7212ead9>En suivant l’exemple de Sainte Thérèse de Lisieux, la Petite Voie est un mouvement qui a pour vision d’imprimer une nouvelle civilisation de l’Amour au monde entier en contribuant à inverser l’individualisme et le manque d’amour observés dans le monde. Être plus humain en aimant davantage le prochain comme soi-même et comme Dieu nous aime puis offrir des opportunités qui induisent le développement intégral. Créer un réseau mondial de chrétiens vecteurs de paix et d’amour ; une Cité de Paix, d’Amour et de joie ; une communauté où chaque individu pourra mettre ses compétences à la disposition des autres. Les actions de la Petite Voie sont portées par la prière individuelle et la pratique de la Lectio Divina. </span></div></div></div></div><br data-v-7212ead9><br data-v-7212ead9><br data-v-7212ead9>", 4)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "blog-card style1" }
const _hoisted_9 = {
  class: "blog-info",
  style: {"min-height":"250px"}
}
const _hoisted_10 = { class: "blog-metainfo list-style" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.truncatedArticles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "blog-img",
                style: _normalizeStyle({height:'277px', backgroundImage: `url(${_ctx.getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'})
              }, null, 4),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", null, [
                    _hoisted_11,
                    _createTextVNode(),
                    _createVNode(_component_router_link, { to: "#" }, {
                      default: _withCtx(() => [
                        _createTextVNode("L' École d’Initiation Théologique et Pastorale")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_12,
                    _createTextVNode(_toDisplayString(_ctx.format_Date(article.datePublication)), 1)
                  ])
                ]),
                _createElementVNode("h3", null, [
                  _createVNode(_component_router_link, {
                    to: { name: 'ViewArticlePage', params: { id: article.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(article.titre), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'ViewArticlePage', params: { id: article.id } },
                  class: "link style1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lire plus "),
                    _hoisted_13
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}